const AUTH_RETURN_TO_KEY = 'auth:returnTo';

const isLocalDevelopmentUrl = (url: URL) => import.meta.env.DEV && ['localhost', '127.0.0.1'].includes(url.hostname);

const isSputnikUrl = (url: URL) =>
    url.protocol === 'https:' && (url.hostname === 'sputnik-go.com' || url.hostname.endsWith('.sputnik-go.com'));

export const getSafeAuthReturnTo = (value: string | null): string | null => {
    if (!value) {
        return null;
    }

    try {
        const url = new URL(value, window.location.origin);

        if (url.origin === window.location.origin || isLocalDevelopmentUrl(url) || isSputnikUrl(url)) {
            return url.toString();
        }
    } catch {
        return null;
    }

    return null;
};

export const storeAuthReturnTo = (returnTo: string | null) => {
    if (returnTo) {
        window.sessionStorage.setItem(AUTH_RETURN_TO_KEY, returnTo);
    }
};

export const consumeAuthReturnTo = () => {
    const returnTo = getSafeAuthReturnTo(window.sessionStorage.getItem(AUTH_RETURN_TO_KEY));
    window.sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
    return returnTo;
};
